import type InviteModel from 'garaje/models/invite';

/**
 * True when an invite went through a workflow,
 * meaning editing + saving will trigger a fresh workflow re-evaluation.
 */
export function canTriggerWorkflowReeval(invite: InviteModel): boolean {
  return !!invite.visitApproval?.visitWorkflowResult;
}
